"use client";

import { Portal } from "@radix-ui/react-portal";
import { ComponentProps, memo, useEffect, useState } from "react";

import { renderEmbedContent } from "./RenderEmbedClientSide.js";

const CustomPortal = memo(
  ({
    content,
    getVideoAspect,
    ...props
  }: ComponentProps<typeof Portal> & { getVideoAspect }) => {
    useEffect(() => {}, []);
    return (
      <Portal {...props}>{renderEmbedContent(content, getVideoAspect)}</Portal>
    );
  }
);

export function EmbedContentInlineRenderer({ body, getVideoAspect, prefix }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;
  return (
    <>
      {body.content
        .filter(
          (content) =>
            typeof content?.attrs?.["data-id"] === "number" ||
            typeof content?.attrs?.["data-id"] === "string"
        )
        .map((content) => {
          const container = document.getElementById(prefix);
          const element = container?.querySelector(
            `[data-id='${content.attrs["data-id"]}']`
          );
          return (
            <CustomPortal
              key={`embed-content-inline-${content.attrs["data-id"]}-${content.attrs.key}`}
              container={element}
              content={content}
              getVideoAspect={getVideoAspect}
            />
          );
        })}
    </>
  );
}
